import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React__default, { forwardRef, Children } from 'react';
import * as Tooltip from '@radix-ui/react-tooltip';
import { Classes } from '@blueprintjs/core';
import cx from 'classnames';
import { usePopperJsPositioning } from '../popover/utils.js';
import { Slot } from '@radix-ui/react-slot';

var _excluded = ["children", "className", "content", "contentWrapperProps", "defaultOpen", "delayDuration", "disabled", "invert", "onOpenChange", "open", "placement"];
var TooltipV2 = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      content = _ref.content,
      contentWrapperProps = _ref.contentWrapperProps,
      defaultOpen = _ref.defaultOpen,
      _ref$delayDuration = _ref.delayDuration,
      delayDuration = _ref$delayDuration === void 0 ? 700 : _ref$delayDuration,
      disabled = _ref.disabled,
      invert = _ref.invert,
      onOpenChange = _ref.onOpenChange,
      open = _ref.open,
      placement = _ref.placement,
      otherTriggerProps = _objectWithoutProperties(_ref, _excluded);

  // custom positioning via react-popper
  var _usePopperJsPositioni = usePopperJsPositioning({
    arrowType: "tooltip",
    className: cx(className, Classes.TOOLTIP, {
      "vds-invert": invert
    }),
    content: content,
    contentWrapperProps: contentWrapperProps,
    defaultOpen: defaultOpen,
    onOpenChange: onOpenChange,
    open: open,
    placement: placement,
    triggerRef: ref
  }),
      rootProps = _usePopperJsPositioni.rootProps,
      triggerProps = _usePopperJsPositioni.triggerProps,
      contentProps = _usePopperJsPositioni.contentProps; // Children must only contain a single element. Otherwise, wrap it in a span.


  var modifiedChildren = Children.count(children) === 1 && typeof children !== "string" ? children : /*#__PURE__*/React__default.createElement("span", null, children);

  if (content === null || content === undefined || disabled) {
    // Slot is used to pass all these additional props to the nested child. See any radix-ui `asChild` behavior.
    return /*#__PURE__*/React__default.createElement(Slot, _extends({}, otherTriggerProps, {
      ref: ref
    }), modifiedChildren);
  }

  return /*#__PURE__*/React__default.createElement(Tooltip.Root, _extends({
    delayDuration: delayDuration
  }, rootProps), /*#__PURE__*/React__default.createElement(Tooltip.TooltipTrigger, _extends({
    className: "vds-tooltip-trigger"
  }, otherTriggerProps, triggerProps), modifiedChildren), /*#__PURE__*/React__default.createElement(Tooltip.Content, contentProps));
});

export { TooltipV2 };
//# sourceMappingURL=tooltip-v2.js.map
